import { Dialog, DialogFooter, PrimaryButton, DefaultButton, DialogType } from '@fluentui/react';
import { useIntl } from 'react-intl';

interface AuthErrorDialogProps {
  isOpen: boolean;
  onDismiss: () => void;
  onReload: () => void;
  onLogin: () => void;
}

const AuthErrorDialog = ({ isOpen, onDismiss, onReload, onLogin }: AuthErrorDialogProps) => {
  const intl = useIntl();

  return (
    <Dialog
      hidden={!isOpen}
      onDismiss={onDismiss}
      dialogContentProps={{
        type: DialogType.largeHeader,
        title: intl.formatMessage({ id: 'candidateReport.auth.title' }),
        subText: intl.formatMessage({ id: 'candidateReport.auth.expired' }),
      }}
    >
      <DialogFooter>
        <PrimaryButton onClick={onReload} text={intl.formatMessage({ id: 'candidateReport.buttons.reload' })} />
        <DefaultButton onClick={onLogin} text={intl.formatMessage({ id: 'candidateReport.buttons.login' })} />
      </DialogFooter>
    </Dialog>
  );
};

export default AuthErrorDialog;
